import { Button, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import ModalV2 from '/@/components/bayer/modal-v2';
import { useDeleteActivity } from '/@/hooks/activities';
import { _ } from '/@/locale';

const DeleteActivityModal = ({
    activityId,
    activityName,
    open,
    setOpen,
}: {
    activityId: number;
    activityName: string;
    open: boolean;
    setOpen: (open: boolean) => void;
}) => {
    const deleteActivityMutation = useDeleteActivity({ activityId });

    const handleDeleteActivity = async () => {
        try {
            await deleteActivityMutation.trigger();
            setOpen(false);
        } catch {
            enqueueSnackbar(_('Error al eliminar la actividad'), {
                variant: 'error',
            });
        }
    };

    return (
        // MUI's Modal portals its content to document.body, but React's synthetic events still
        // bubble through the component tree — without this, clicking inside bubbles up into
        // ActivityCard's onClick and opens the edit form. Not an interactive element itself,
        // just an event-propagation boundary, so no keyboard handler/role is needed.
        // biome-ignore lint/a11y/useKeyWithClickEvents: non-interactive propagation boundary
        // biome-ignore lint/a11y/noStaticElementInteractions: non-interactive propagation boundary
        <div onClick={(e) => e.stopPropagation()}>
            <ModalV2
                open={open}
                onClose={() => setOpen(false)}
                title={_('Eliminar actividad')}
                actions={
                    <>
                        <Button
                            variant='text'
                            color='secondary'
                            onClick={() => setOpen(false)}
                            disabled={deleteActivityMutation.isMutating}
                        >
                            {_('Cancelar')}
                        </Button>
                        <Button
                            variant='contained'
                            color='secondary'
                            onClick={() => handleDeleteActivity()}
                            disabled={deleteActivityMutation.isMutating}
                        >
                            {_('Eliminar actividad')}
                        </Button>
                    </>
                }
                actionsProps={{
                    justifyContent: 'end',
                }}
            >
                <Typography variant='body1' color='primary'>
                    {_(
                        '¿Estás seguro que querés eliminar la actividad "{{activityName}}"? Esta acción no se puede deshacer.',
                        {
                            activityName,
                        }
                    )}
                </Typography>
            </ModalV2>
        </div>
    );
};

export default DeleteActivityModal;
